import { Image } from 'expo-image'
import React from 'react'
import { Pressable, Text, View } from 'react-native'

import { IMAGE } from '@ui-kit/assets/images/index.native'
import Icon from '@ui-kit/components/Icon'
import Tag from '@ui-kit/components/Tag'
import { textColor } from '@ui-kit/styles/colors'
import { paddingY } from '@ui-kit/styles/padding'

import * as styles from './styles'
import type { NativeListItemProps } from './types'
import { getTitleColor } from './utils'

const ListItem = (props: NativeListItemProps): JSX.Element => {
  const {
    container,
    imageContainer,
    image,
    content,
    textContainer,
    subtitle,
    title,
    tagContainer,
    rightContentContainer,
    iconContainer,
  } = styles.listItem({
    pressable: Boolean(props.onPress),
    isCompleted: props.isCompleted,
    image: props.imageSize,
    bordered: props.bordered,
    lineThrough: props.lineThrough,
    underlinedTitle: props.underlinedTitle,
  })
  return (
    <Pressable className={container()} onPress={props.onPress} testID={props.id}>
      {props.image && props.imageSize && (
        <View className={imageContainer()}>
          {typeof props.image === 'string' ? (
            <Image
              className={image()}
              source={props.image}
              alt={`Illustration of ${props.title}`}
            />
          ) : (
            props.image
          )}
        </View>
      )}
      <View className={content({ className: paddingY({ space: props.paddingY ?? 'small' }) })}>
        <View className={textContainer()}>
          {props.tagLabel && (
            <View className={tagContainer()}>
              <Tag label={props.tagLabel} />
            </View>
          )}
          <Text
            className={title({
              className: textColor({ color: getTitleColor(props.color, props.underlinedTitle) }),
            })}
          >
            {props.title}
          </Text>
          {props.subtitle ? (
            <Text
              className={subtitle({
                className: textColor({ color: props.subtitleColor ?? props.color }),
              })}
            >
              {props.subtitle}
            </Text>
          ) : null}
        </View>
        <View className={rightContentContainer()}>
          {props.rightContent}
          {props.icon !== 'none' ? (
            <View className={iconContainer()}>
              {props.icon ? props.icon : <Icon imgSrc={IMAGE.icons.small.action.chevronRight_24} />}
            </View>
          ) : null}
        </View>
      </View>
    </Pressable>
  )
}
export default ListItem
